export const stringToPrimitive = (value: string): boolean | string => {
	switch (value) {
		case 'true': return true;
		case 'false': return false;
		case 'null': return null;
		case 'undefined': return undefined;
		default: return value;
	}
};
